import React from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { campaignsList } from 'Router/routes'
import { WhiteGreenBtnMoreWide } from 'Stories/Button/Button.stories'
import { IconSuccessfully } from 'Stories/Icon/Icon.stories'
import { CampaignIsScheduledComponentProps } from './props'

import {
  CustomModal,
  SuccessBlock,
  SuccessButtonBlock,
  SuccessText,
  SuccessCircle,
  TitleWrapper,
} from './styles'

const CampaignIsScheduledComponent: React.FC<CampaignIsScheduledComponentProps> = ({
  startDate,
}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const localtz = moment.tz.guess()
  const onlyDate = moment(startDate)
    .tz(localtz)
    .format('MMMM Do')

  const timeAndTimezone = moment(startDate)
    .tz(localtz)
    .format('h:mm A z')

  const dateToShow = `${onlyDate} at ${timeAndTimezone}`

  return (
    <CustomModal>
      <SuccessBlock>
        <SuccessCircle>
          <IconSuccessfully />
        </SuccessCircle>
        <TitleWrapper>
          <span>{t('scheduleCampaignPage.awesome')}</span>
          <span role="img" aria-label="party">
            &#127881;
          </span>
        </TitleWrapper>

        <SuccessText>
          {t(
            'scheduleCampaignPage.awesomeYourCampaignIsScheduledAndWillStartOn'
          )}
          &nbsp;
          {dateToShow}
        </SuccessText>

        <SuccessButtonBlock>
          <WhiteGreenBtnMoreWide
            color="whiteGreenMoreWide"
            onClick={() => {
              history.push(`${campaignsList}`)
            }}
          >
            {t('scheduleCampaignPage.goToCampaigns')}
          </WhiteGreenBtnMoreWide>
        </SuccessButtonBlock>
      </SuccessBlock>
    </CustomModal>
  )
}

export default CampaignIsScheduledComponent
